var $ = require("jquery");

$('.event').each(function () {
  const $truncated = $(this).find('.truncated'),
        $untruncated = $(this).find('.untruncated'),

        morebutton = $(this).find('.truncated a.more-button'),
        lessbutton = $(this).find('.untruncated a.less-button'),

        readordie = function () {
          $untruncated.toggleClass('read');
          $truncated.toggleClass('die');
         };

  morebutton.click(readordie);
  lessbutton.click(readordie);
});

